module.exports = __webpack_public_path__ + "static/media/search-by-algolia-dark-background.0de639a6.svg";